/* eslint-disable */
import _ from 'lodash';
import { FilterType } from 'utilities/enum-utils';

export const mapBookingViewFilterPayload = (filterValue) => {
  if (!filterValue) return [];

  return _.cloneDeep(filterValue)
    .filter((filter) => !Object.keys(filter).includes('search'))
    .map((filter) => {
      if (Object.keys(filter).includes(FilterType.CUSTOMER)) {
        filter[FilterType.CUSTOMER] = _.map(filter[FilterType.CUSTOMER], (customer) => {
          const { name, value, displayText } = customer;
          return { displayText: name || displayText, value };
        });
      }
      return filter;
    });
};
